import { Reducer } from "redux";
import {
    PatientInformationFormState,
    PatientInformationFormActions,
    PatientInfoSendingMode,
    PATIENT_INFO_MODE,
    PatientCreationSuccessfulAction,
    StagePatientDataInfoAction,
    TogglePatientInformationEditPopupAction,
    SaveEmailEditAction,
    SavePhoneEditAction,
    SaveAddressEditAction,
    SaveDemographicsEditAction,
    PATIENT_OVERVIEW_EDIT_WINDOW,
    SavePreferredPharmacyEditAction
} from "./type";
import {
    SELECT_PATIENT_INFO_MODE,
    TOGGLE_PATIENT_INFO_EDIT_POPUP,
    SAVE_PATIENT_EMAILS,
    SAVE_PATIENT_PHONES,
    SAVE_PATIENT_ADDRESSES,
    SAVE_PATIENT_DEMOGRAPHICS,
    SAVE_PATIENT_PREFERRED_PHARMACY,
    PATIENT_CREATION_SUCCESSFUL,
    STAGE_PATIENT_DATA,
} from "./constants";
import {
    setPatientCreationSuccessfulHandler,
    selectPatientInfoModeHandler,
    stagePatientDataHandler,
    saveEmailDataHandler,
    savePhoneDataHandler,
    saveAddressDataHandler,
    saveDemographicsDataHandler,
    togglePatientInformationEditPopupHandler,
    savePreferredPharmacyDataHandler
} from "./handlers";


/**
 * @name initialState
 * @type PatientInformationFormState
 * @export
 * @description Initial state for this feature.
 */
export const initialState: PatientInformationFormState = {
    patientInformation: {
        patientContactFacetId: "",
        patientId: "",
        healthCard: {
            number: "",
            expiryDate: ""
        },
        demographics: {
            dateOfBirth: "",
            firstName: "",
            lastName: "",
            sexAtBirth: "",
            genderIdentity: "",
            preferredName: "",
            preferredPronouns: "",
            specifiedPreferredPronouns: "",
            prefix: ""
        },
        emails: [],
        addresses: [],
        phones: [],
        preferredPharmacy: {
            directoryPharmacyId: "0000",
            id: 1,
            name: "",
            phone: "",
            fax: "",
            address: "",
            banner: "",
            isMylePharmacy: false
        }
    },
    patientInfoChanged: false,
    patientInterfaceForm: {
        patientCreated: false,
        currentPatientInfoMode: PATIENT_INFO_MODE.NOT_CHOSEN,
        showDateSelector: false,
        phoneOption1ExtVisible: false,
        phoneOption2ExtVisible: false,
        phoneEditStatus: false,
        emailEditStatus: false,
        addressTabIndex: 0,
        patientInfoEditIsNewItem: false,
        patientInfoEditPopupVisible: false,
        patientInfoEditIndex: 0,
        patientInfoEditSelectedCategory: 0,

        patientInfoEditDeletePopupVisible: false,
        patientInfoDeletePopupCategory: PATIENT_OVERVIEW_EDIT_WINDOW.NONE,
    },
};

/**
 * @name reducer
 * @description Function that dispatches the action to the proper handler.
 * @param state 
 * @param action 
 */
const reducer: Reducer<PatientInformationFormState> = (state: PatientInformationFormState = initialState, action: PatientInformationFormActions) => {
    switch (action.type) {
        case PATIENT_CREATION_SUCCESSFUL:
            return setPatientCreationSuccessfulHandler(state, action as PatientCreationSuccessfulAction);

        case SELECT_PATIENT_INFO_MODE:
            return selectPatientInfoModeHandler(state, action as PatientInfoSendingMode);

        case STAGE_PATIENT_DATA:
            return stagePatientDataHandler(state, action as StagePatientDataInfoAction);

        case TOGGLE_PATIENT_INFO_EDIT_POPUP:
            return togglePatientInformationEditPopupHandler(state, action as TogglePatientInformationEditPopupAction);

        case SAVE_PATIENT_EMAILS:
            return saveEmailDataHandler(state, action as SaveEmailEditAction);

        case SAVE_PATIENT_PHONES:
            return savePhoneDataHandler(state, action as SavePhoneEditAction);

        case SAVE_PATIENT_ADDRESSES:
            return saveAddressDataHandler(state, action as SaveAddressEditAction);

        case SAVE_PATIENT_DEMOGRAPHICS:
            return saveDemographicsDataHandler(state, action as SaveDemographicsEditAction);

        case SAVE_PATIENT_PREFERRED_PHARMACY:
            return savePreferredPharmacyDataHandler(state, action as SavePreferredPharmacyEditAction);

        default:
            return state;
    }
};

export default reducer;SAVE_PATIENT_ADDRESSES


// WEBPACK FOOTER //
// ./src/store/PatientInformationForm/reducer.ts